<template>
    <client-only>
        <div>
            <h6 class="text-h6">
                {{ $t('tours.available_travel_start_dates') }}
            </h6>
            <!-- eslint-disable vue/no-custom-modifiers-on-v-model -->
            <vc-date-picker
                v-model.string="date"
                :masks="masks"
                :locale="$i18n.locale"
                :columns="$breakpoint.lgAndDown ? 1 : 2"
                is-expanded
                :available-dates="availableDates"
                :first-day-of-week="$conf.public.firstDayOfWeek || undefined"
                is-required
            />
        </div>
    </client-only>
</template>

<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import {TourDatepickerMixin} from '@/components/tours/mixins/TourDatepickerMixin.vue'

    @Component
    export class TourDatepicker extends mixins(TourDatepickerMixin) {
        @Prop({required: true}) searchRequest

        get masks() {
            return {modelValue: 'YYYY-MM-DD'}
        }

        get date() {
            return this.searchRequest.startDateFrom
        }

        set date(startDateFrom) {
            try {
                this.$router.push({
                    name: 'tour',
                    query: Object.assign({}, this.$route.query, {
                        startDateFrom,
                        startDateTo: startDateFrom,
                    }),
                })
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }
    }

    export default TourDatepicker
</script>
